import { CommentAnchorType } from '@marketing-milk/interfaces'

// Comment anchor types the UI knows how to open. Shared by the packet click
// delegation (useCommentAnchors) and any surface that handles a Slack comment
// deep-link (the packet hosts and the native audience list).
export const KNOWN_TYPES: CommentAnchorType[] = [
  'section',
  'narrative-block',
  'performance-metric',
  'creative',
  'audience',
]

// Parse + validate a Slack comment deep-link (`?anchorType=&anchorId=`). Returns
// null when the params are absent or the type isn't one we recognize, so callers
// get the same `KNOWN_TYPES` guard the click handler applies.
export const readCommentDeepLink = (
  search: string = window.location.search
): { anchorType: CommentAnchorType; anchorId: string } | null => {
  const params = new URLSearchParams(search)
  const anchorType = params.get('anchorType')
  const anchorId = params.get('anchorId')
  if (!anchorType || !anchorId) return null
  if (!KNOWN_TYPES.includes(anchorType as CommentAnchorType)) return null
  return { anchorType: anchorType as CommentAnchorType, anchorId }
}
